import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { ElementRef, Component, ViewEncapsulation, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { __decorate, __metadata } from 'tslib';
import * as i1 from '@sick-curie/dashboard-builder-core';
import { FunctionExecutionService } from '@sick-curie/dashboard-builder-core';
import { WaitingForBindingValueEvent, BindingRemovedEvent, AngularDashboardElement } from '@sick-curie/dashboard-builder-ui-models';
import { firstValueFrom, of } from 'rxjs';

let DataConverterComponent = class DataConverterComponent {
    constructor(elRef, functionExecutionService) {
        this.elRef = elRef;
        this.functionExecutionService = functionExecutionService;
        this.values = [];
        this.lastParent = undefined;
        this.indexesWithValues = new Set();
        this.obs = new MutationObserver((mutations) => {
            mutations
                .map((mutation) => mutation.removedNodes)
                .reduce((acc, cur) => [...acc, ...Array.from(cur)], [])
                .map((node) => Number(node.property.substr('value'.length)))
                .forEach((index) => delete this.values[index]);
        });
        this.obs.observe(this.elRef.nativeElement, { childList: true });
    }
    ngOnInit() {
        setTimeout(() => {
            // ngOnDestroy of previous instance needs to be run first
            this.elRef.nativeElement.dispatchEvent(new WaitingForBindingValueEvent(true, this.property));
        });
        this.lastParent = this.elRef.nativeElement.parentElement;
    }
    ngOnDestroy() {
        this.lastParent?.dispatchEvent(new BindingRemovedEvent(this.property));
        this.lastParent?.dispatchEvent(new WaitingForBindingValueEvent(false, this.property));
        this.obs.disconnect();
    }
    ngOnChanges(changes) {
        for (let i = 0; i < 100; i++) {
            const change = changes[`value${i}`];
            if (!change) {
                continue;
            }
            this.newValue(change.currentValue, i);
        }
    }
    async newValue(value, i = 0) {
        this.indexesWithValues.add(i);
        if (this.indexesWithValues.size === this.elRef.nativeElement.childNodes.length) {
            this.elRef.nativeElement.dispatchEvent(new WaitingForBindingValueEvent(false, this.property));
        }
        this.values[i] = value;
        const parent = this.elRef.nativeElement.parentElement;
        if (!parent) {
            return;
        }
        this.lastParent = parent;
        if (this.wiringFunction) {
            await firstValueFrom(of([parent, ...this.values]).pipe(this.functionExecutionService.run(this.wiringFunction)));
        }
        if (this.propertyIsArray) {
            const newArrValue = [];
            Array.from(parent[this.property])?.forEach((value, i) => (newArrValue[i] = value));
            this.values.forEach((value, i) => (newArrValue[i] = value));
            parent[this.property] = [...newArrValue];
        }
        else {
            parent[this.property] = this.values[i];
        }
    }
};
DataConverterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DataConverterComponent, deps: [{ token: i0.ElementRef }, { token: i1.FunctionExecutionService }], target: i0.ɵɵFactoryTarget.Component });
DataConverterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.4", type: DataConverterComponent, selector: "dashboard-data-converter", inputs: { value0: "value0", value1: "value1", value2: "value2", value3: "value3", value4: "value4", value5: "value5", value6: "value6", value7: "value7", value8: "value8", value9: "value9", value10: "value10", value11: "value11", value12: "value12", value13: "value13", value14: "value14", value15: "value15", value16: "value16", value17: "value17", value18: "value18", value19: "value19", value20: "value20", value21: "value21", value22: "value22", value23: "value23", value24: "value24", value25: "value25", value26: "value26", value27: "value27", value28: "value28", value29: "value29", value30: "value30", value31: "value31", value32: "value32", value33: "value33", value34: "value34", value35: "value35", value36: "value36", value37: "value37", value38: "value38", value39: "value39", value40: "value40", value41: "value41", value42: "value42", value43: "value43", value44: "value44", value45: "value45", value46: "value46", value47: "value47", value48: "value48", value49: "value49", value50: "value50", value51: "value51", value52: "value52", value53: "value53", value54: "value54", value55: "value55", value56: "value56", value57: "value57", value58: "value58", value59: "value59", value60: "value60", value61: "value61", value62: "value62", value63: "value63", value64: "value64", value65: "value65", value66: "value66", value67: "value67", value68: "value68", value69: "value69", value70: "value70", value71: "value71", value72: "value72", value73: "value73", value74: "value74", value75: "value75", value76: "value76", value77: "value77", value78: "value78", value79: "value79", value80: "value80", value81: "value81", value82: "value82", value83: "value83", value84: "value84", value85: "value85", value86: "value86", value87: "value87", value88: "value88", value89: "value89", value90: "value90", value91: "value91", value92: "value92", value93: "value93", value94: "value94", value95: "value95", value96: "value96", value97: "value97", value98: "value98", value99: "value99", property: "property", propertyIsArray: "propertyIsArray", wiringFunction: "wiringFunction" }, usesOnChanges: true, ngImport: i0, template: '', isInline: true, encapsulation: i0.ViewEncapsulation.ShadowDom });
DataConverterComponent = __decorate([
    AngularDashboardElement({
        role: 'behavior',
        documentation: {
            name: 'Dashboard Builder Data Converter',
            description: '',
        },
    }),
    __metadata("design:paramtypes", [ElementRef, FunctionExecutionService])
], DataConverterComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DataConverterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dashboard-data-converter',
                    template: '',
                    encapsulation: ViewEncapsulation.ShadowDom,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.FunctionExecutionService }]; }, propDecorators: { value0: [{
                type: Input
            }], value1: [{
                type: Input
            }], value2: [{
                type: Input
            }], value3: [{
                type: Input
            }], value4: [{
                type: Input
            }], value5: [{
                type: Input
            }], value6: [{
                type: Input
            }], value7: [{
                type: Input
            }], value8: [{
                type: Input
            }], value9: [{
                type: Input
            }], value10: [{
                type: Input
            }], value11: [{
                type: Input
            }], value12: [{
                type: Input
            }], value13: [{
                type: Input
            }], value14: [{
                type: Input
            }], value15: [{
                type: Input
            }], value16: [{
                type: Input
            }], value17: [{
                type: Input
            }], value18: [{
                type: Input
            }], value19: [{
                type: Input
            }], value20: [{
                type: Input
            }], value21: [{
                type: Input
            }], value22: [{
                type: Input
            }], value23: [{
                type: Input
            }], value24: [{
                type: Input
            }], value25: [{
                type: Input
            }], value26: [{
                type: Input
            }], value27: [{
                type: Input
            }], value28: [{
                type: Input
            }], value29: [{
                type: Input
            }], value30: [{
                type: Input
            }], value31: [{
                type: Input
            }], value32: [{
                type: Input
            }], value33: [{
                type: Input
            }], value34: [{
                type: Input
            }], value35: [{
                type: Input
            }], value36: [{
                type: Input
            }], value37: [{
                type: Input
            }], value38: [{
                type: Input
            }], value39: [{
                type: Input
            }], value40: [{
                type: Input
            }], value41: [{
                type: Input
            }], value42: [{
                type: Input
            }], value43: [{
                type: Input
            }], value44: [{
                type: Input
            }], value45: [{
                type: Input
            }], value46: [{
                type: Input
            }], value47: [{
                type: Input
            }], value48: [{
                type: Input
            }], value49: [{
                type: Input
            }], value50: [{
                type: Input
            }], value51: [{
                type: Input
            }], value52: [{
                type: Input
            }], value53: [{
                type: Input
            }], value54: [{
                type: Input
            }], value55: [{
                type: Input
            }], value56: [{
                type: Input
            }], value57: [{
                type: Input
            }], value58: [{
                type: Input
            }], value59: [{
                type: Input
            }], value60: [{
                type: Input
            }], value61: [{
                type: Input
            }], value62: [{
                type: Input
            }], value63: [{
                type: Input
            }], value64: [{
                type: Input
            }], value65: [{
                type: Input
            }], value66: [{
                type: Input
            }], value67: [{
                type: Input
            }], value68: [{
                type: Input
            }], value69: [{
                type: Input
            }], value70: [{
                type: Input
            }], value71: [{
                type: Input
            }], value72: [{
                type: Input
            }], value73: [{
                type: Input
            }], value74: [{
                type: Input
            }], value75: [{
                type: Input
            }], value76: [{
                type: Input
            }], value77: [{
                type: Input
            }], value78: [{
                type: Input
            }], value79: [{
                type: Input
            }], value80: [{
                type: Input
            }], value81: [{
                type: Input
            }], value82: [{
                type: Input
            }], value83: [{
                type: Input
            }], value84: [{
                type: Input
            }], value85: [{
                type: Input
            }], value86: [{
                type: Input
            }], value87: [{
                type: Input
            }], value88: [{
                type: Input
            }], value89: [{
                type: Input
            }], value90: [{
                type: Input
            }], value91: [{
                type: Input
            }], value92: [{
                type: Input
            }], value93: [{
                type: Input
            }], value94: [{
                type: Input
            }], value95: [{
                type: Input
            }], value96: [{
                type: Input
            }], value97: [{
                type: Input
            }], value98: [{
                type: Input
            }], value99: [{
                type: Input
            }], property: [{
                type: Input
            }], propertyIsArray: [{
                type: Input
            }], wiringFunction: [{
                type: Input
            }] } });

class DashboardBuilderDataConverterModule {
}
DashboardBuilderDataConverterModule.REGISTER = [DataConverterComponent];
DashboardBuilderDataConverterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DashboardBuilderDataConverterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DashboardBuilderDataConverterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DashboardBuilderDataConverterModule, declarations: [DataConverterComponent], imports: [CommonModule] });
DashboardBuilderDataConverterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DashboardBuilderDataConverterModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.4", ngImport: i0, type: DashboardBuilderDataConverterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [DataConverterComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DashboardBuilderDataConverterModule };
